package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_05_24_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-05-24")
@Composable
public fun Log_2024_05_24(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Shard of Concar Recovered",
        ogTitle = "Shard of Concar Recovered",
        date = LocalDate(2_024, 5, 24),
        ogDescription = "After slaying Jarb, the heroes solve a mechanical puzzle to recover a shard of Concar and teleport back to Malus.",
        ogImage = "ai/2024-05-24.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
        Log_2024_05_24_Day_1()
    }
}
